var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    fill: "#99FF7D",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.701 5.33325H42.2758C50.8447 5.33325 55.9768 10.5371 56 19.2258V44.774C56 53.4628 50.8911 58.6666 42.299 58.6666H34.6821C33.7053 58.5574 32.966 57.7205 32.966 56.724C32.966 55.7275 33.7053 54.8906 34.6821 54.7814H42.2758C48.8244 54.7814 52.1219 51.4142 52.1219 44.774V19.2258C52.1219 12.5856 48.8244 9.21846 42.2758 9.21846H21.701C15.1524 9.21846 11.8316 12.5856 11.8316 19.2258V44.774C11.8316 51.4142 15.1524 54.7814 21.701 54.7814C22.6778 54.8906 23.4172 55.7275 23.4172 56.724C23.4172 57.7205 22.6778 58.5574 21.701 58.6666C13.1321 58.6666 8 53.4628 8 44.774V19.2258C8 10.5135 13.1321 5.33325 21.701 5.33325ZM22.3745 22.6636H29.6894C30.6662 22.5544 31.4056 21.7175 31.4056 20.721C31.4056 19.7246 30.6662 18.8876 29.6894 18.7784H22.3745C21.3976 18.8876 20.6583 19.7246 20.6583 20.721C20.6583 21.7175 21.3976 22.5544 22.3745 22.6636ZM41.5791 33.9425H22.3745H22.3512C21.3744 33.8333 20.635 32.9964 20.635 31.9999C20.635 31.0034 21.3744 30.1665 22.3512 30.0573H41.5791C42.3139 29.9752 43.0303 30.3264 43.4232 30.9614C43.816 31.5965 43.816 32.4034 43.4232 33.0384C43.0303 33.6734 42.3139 34.0247 41.5791 33.9425ZM41.5791 45.2214H22.3745H22.3512C21.2996 45.2214 20.447 44.3569 20.447 43.2906C20.447 42.2242 21.2996 41.3597 22.3512 41.3597H41.5791C42.6308 41.3597 43.4833 42.2242 43.4833 43.2906C43.4833 44.3569 42.6308 45.2214 41.5791 45.2214Z",
    fill: "#139C33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.93465ea16a92acb5d9d5f5f402e60879.svg";
export { ForwardRef as ReactComponent };